/* Sansu theme — shared behaviour: nav, menus, search, theme toggle, reveal, money, recommendations. */
(function () {
  const S = window.Sansu = window.Sansu || {};
  S.strings = S.strings || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const design = window.Shopify && Shopify.designMode;

  /* ---------- Broken pictures in descriptions and pages ----------
     Text pasted into a product or page can carry pictures that never load (a bad copy-paste leaves an
     unreadable embedded image). They are hidden, together with the empty paragraph around them, so a visitor
     never sees a broken-image icon. The content itself is not touched. */
  const hideBroken = img => {
    img.hidden = true; img.style.display = 'none';
    const box = img.parentElement;
    if (box && /^(P|DIV|FIGURE|SPAN)$/.test(box.tagName) && box.closest('.rte') && !box.textContent.trim() && ![...box.querySelectorAll('img')].some(i => !i.hidden)) box.style.display = 'none';
  };
  // Empty boxes holding only line breaks (typical of text pasted from Amazon or Word) would stack up as blank space.
  const MEDIA = 'img, svg, iframe, video, picture, table, hr, input, button, canvas';
  const tidyEmpty = () => $$('.rte div, .rte p, .rte section, .rte span').forEach(b => {
    if (!b.textContent.trim() && !b.querySelector(MEDIA) && getComputedStyle(b).display !== 'none') b.style.display = 'none';
  });
  const sweepBroken = () => { $$('.rte img').forEach(i => { if (i.complete && i.naturalWidth === 0) hideBroken(i); }); tidyEmpty(); };
  document.addEventListener('error', e => { if (e.target && e.target.tagName === 'IMG' && e.target.closest && e.target.closest('.rte')) hideBroken(e.target); }, true);
  document.readyState === 'complete' ? sweepBroken() : addEventListener('load', sweepBroken);

  /* ---------- Money (Shopify money_format) ---------- */
  S.formatMoney = function (cents, trimZeros) {
    cents = Math.round(+cents || 0);
    const fmt = S.moneyFormat || 'Rs. {{amount}}';
    const withDelims = (n, d, t = ',', dec = '.') => {
      const [i, f] = (n / 100).toFixed(d).split('.');
      // Indian grouping for the Indian formats: 1,00,000
      const int = i.replace(/(\d)(?=(\d\d)+\d$)/g, '$1' + t);
      return f ? int + dec + f : int;
    };
    const m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    let val;
    switch (m && m[1]) {
      case 'amount_no_decimals': val = withDelims(cents, 0); break;
      case 'amount_with_comma_separator': val = withDelims(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': val = withDelims(cents, 0, '.'); break;
      default: val = withDelims(cents, 2);
    }
    if (trimZeros) val = val.replace(/[.,]00$/, '');
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, val);
  };

  /* ---------- Toast ---------- */
  let toastTimer;
  S.toast = function (msg) {
    const t = $('[data-toast]');
    if (!t) return;
    t.textContent = msg; t.classList.add('is-on');
    clearTimeout(toastTimer); toastTimer = setTimeout(() => t.classList.remove('is-on'), 2800);
  };

  /* ---------- Nav: shrink on scroll ---------- */
  const nav = $('[data-nav]');
  if (nav) {
    const phone = matchMedia('(max-width: 899px)');
    const autoHide = document.body.classList.contains('hide-header-on-scroll');
    let lastY = scrollY;
    const onScroll = () => {
      const y = scrollY;
      nav.classList.toggle('is-scrolled', y > 40);
      const menuOpen = document.body.classList.contains('menu-open') || !document.getElementById('HeaderSearch')?.hidden;
      if (autoHide && phone.matches && !menuOpen) {
        if (y > lastY + 6 && y > 160) nav.classList.add('is-hidden');
        else if (y < lastY - 6 || y < 160) nav.classList.remove('is-hidden');
      } else nav.classList.remove('is-hidden');
      lastY = y;
    };
    nav.addEventListener('focusin', () => nav.classList.remove('is-hidden'));
    addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  /* ---------- Mega menus ---------- */
  $$('[data-mega]').forEach(item => {
    const btn = $('[data-mega-toggle]', item);
    let timer;
    const set = open => { item.classList.toggle('is-open', open); btn.setAttribute('aria-expanded', open); };
    if (matchMedia('(hover: hover)').matches) {
      item.addEventListener('mouseenter', () => { clearTimeout(timer); set(true); });
      item.addEventListener('mouseleave', () => { timer = setTimeout(() => set(false), 180); });
    }
    btn.addEventListener('click', () => set(!item.classList.contains('is-open')));
    item.addEventListener('focusout', e => { if (!item.contains(e.relatedTarget)) set(false); });
    // Document-level: a menu opened by hover has no focus inside it, but Escape must still dismiss it
    document.addEventListener('keydown', e => {
      if (e.key !== 'Escape' || !item.classList.contains('is-open')) return;
      const hadFocus = item.contains(document.activeElement);
      set(false);
      if (hadFocus) btn.focus();
    });
  });

  /* ---------- Mobile menu + search panel ---------- */
  function panelToggle(btnSel, panelId, labels, bodyClass) {
    const btns = $$(btnSel), panel = document.getElementById(panelId);
    if (!btns.length || !panel) return;
    const set = (open, from) => {
      panel.hidden = !open;
      btns.forEach(b => { b.setAttribute('aria-expanded', open); if (labels) b.setAttribute('aria-label', open ? labels[1] : labels[0]); });
      if (bodyClass) { document.body.classList.toggle(bodyClass, open); document.documentElement.style.overflow = open ? 'hidden' : ''; }
      if (open) { nav && nav.classList.remove('is-hidden'); (panel.querySelector('input, a, summary') || panel).focus({ preventScroll: true }); }
      else if (from) from.focus({ preventScroll: true });
    };
    btns.forEach(b => b.addEventListener('click', () => set(panel.hidden, b)));
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && !panel.hidden) set(false, btns[0]); });
    // tap outside closes it
    document.addEventListener('click', e => { if (!panel.hidden && !panel.contains(e.target) && !btns.some(b => b.contains(e.target))) set(false); });
    panel.addEventListener('click', e => { if (e.target.closest('a')) set(false); });
  }
  panelToggle('[data-menu-toggle]', 'MobileMenu', [S.strings.openMenu, S.strings.closeMenu], 'menu-open');
  panelToggle('[data-search-toggle]', 'HeaderSearch');

  /* ---------- Light / dark (H14): dark default, remembered per visitor ---------- */
  const themeBtns = $$('[data-theme-toggle]');
  const syncTheme = () => {
    const light = document.documentElement.dataset.theme === 'light';
    themeBtns.forEach(b => b.setAttribute('aria-label', light ? S.strings.toDark : S.strings.toLight));
    const meta = $('meta[name="theme-color"]');
    if (meta) meta.content = getComputedStyle(document.documentElement).getPropertyValue('--bg').trim() || meta.content;
  };
  themeBtns.forEach(b => b.addEventListener('click', () => {
    const next = document.documentElement.dataset.theme === 'light' ? 'dark' : 'light';
    document.documentElement.dataset.theme = next;
    try { localStorage.setItem('sansu-theme', next); } catch (e) { /* storage blocked */ }
    syncTheme();
  }));
  syncTheme();

  /* ---------- Reveal: fade up 24 px at 20% visible, once (Motion §4) ---------- */
  function reveal(scope) {
    const els = $$('.reveal:not(.is-in)', scope);
    if (reduce || design || document.body.classList.contains('no-reveal') || !('IntersectionObserver' in window)) {
      els.forEach(el => el.classList.add('is-in')); return;
    }
    // Fires when the top of a block is 10% into the screen, whatever its height. (A share-of-element
    // threshold never fires for a block taller than the screen allows, such as a long product grid on a phone.)
    const io = new IntersectionObserver(es => es.forEach(e => {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    }), { threshold: 0, rootMargin: '0px 0px -10% 0px' });
    // Anything already scrolled past (fast fling, jump to an anchor, back button) shows at once
    addEventListener('scroll', () => els.forEach(el => { if (!el.classList.contains('is-in') && el.getBoundingClientRect().bottom < 0) { el.classList.add('is-in'); io.unobserve(el); } }), { passive: true });
    els.forEach(el => io.observe(el));
  }

  /* ---------- Count-up stats, once ---------- */
  function countUp(scope) {
    const els = $$('[data-count]', scope);
    const run = el => {
      const end = +el.dataset.count;
      if (reduce || design) { el.textContent = end; return; }
      el.textContent = 0;
      const t0 = performance.now(), dur = 1400;
      const step = t => { const k = Math.min(1, (t - t0) / dur); el.textContent = Math.round(end * (1 - Math.pow(1 - k, 4))); if (k < 1) requestAnimationFrame(step); };
      requestAnimationFrame(step);
    };
    const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { run(e.target); io.unobserve(e.target); } }), { threshold: .6 });
    els.forEach(el => io.observe(el));
  }

  /* ---------- Flip cards (tap / keyboard; hover handled in CSS) ---------- */
  document.addEventListener('click', e => {
    const f = e.target.closest('[data-flip]');
    if (f) f.setAttribute('aria-pressed', f.classList.toggle('is-flipped'));
  });

  /* ---------- Product recommendations (loaded after the page) ---------- */
  function recommendations(scope) {
    $$('[data-recommendations][data-url]', scope).forEach(el => {
      if (el.dataset.loaded) return;
      const load = async () => {
        el.dataset.loaded = '1';
        try {
          const html = await (await fetch(el.dataset.url)).text();
          const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-recommendations]');
          if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; el.classList.add('has-items'); reveal(el); }
        } catch (err) { /* recommendations are optional */ }
      };
      // Load when the section comes near, or once it is already above the screen: a fast fling, a jump link
      // or back-button scroll restore can skip straight past it, and the observer never sees it intersect.
      const io = new IntersectionObserver(es => { if (es[0].isIntersecting) start(); }, { rootMargin: '400px 0px' });
      const onScroll = () => { if (el.getBoundingClientRect().top < innerHeight + 400) start(); };
      const start = () => { io.disconnect(); removeEventListener('scroll', onScroll); if (!el.dataset.loaded) load(); };
      io.observe(el);
      addEventListener('scroll', onScroll, { passive: true });
    });
  }
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-add-all]');
    if (!b || !S.cart) return;
    const ids = b.dataset.addAll.split(',').filter(Boolean);
    S.cart.add(ids.map(id => ({ id: +id, quantity: 1 })));
  });

  /* ---------- Touch screens: hover effects play by themselves ----------
     A phone has no mouse, so the card, tile or video passing through the middle of the screen gets the look a
     mouse hover gives on desktop (second photo, glow, lifted art). Cards added later (filters, "load more",
     recommendations) are picked up too. */
  if (matchMedia('(hover: none)').matches && !reduce && !design && 'IntersectionObserver' in window) {
    const HOVERABLE = '.card, .tile, .reel, .article-card';
    const io = new IntersectionObserver(es => es.forEach(e => e.target.classList.toggle('is-hover', e.isIntersecting)), { rootMargin: '-40% 0px -40% 0px' });
    const watch = root => (root.matches && root.matches(HOVERABLE) ? [root] : []).concat($$(HOVERABLE, root)).forEach(el => { if (!el.dataset.touchHover) { el.dataset.touchHover = '1'; io.observe(el); } });
    watch(document);
    new MutationObserver(ms => ms.forEach(m => m.addedNodes.forEach(n => { if (n.nodeType === 1) watch(n); }))).observe(document.body, { childList: true, subtree: true });
  }

  const initAll = scope => { reveal(scope); countUp(scope); recommendations(scope); };
  initAll(document);
  document.addEventListener('shopify:section:load', e => initAll(e.target));
})();
